import { useQuery } from '@tanstack/react-query';

import { getV1UserCurrentOauthClientsOptions } from '../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the app catalog (the OAuth clients the current User may launch).
 *
 * Thin wrapper over the generated `@hey-api` react-query options; see
 * `../Settings/IdentityProviders/identityProviders.queries.ts` for the pattern.
 */

export const useOauthClients = () => useQuery(getV1UserCurrentOauthClientsOptions());
